<template>
    <div>
        <!-- Password input field -->
        <div :class="passwordInputClass">
            <label
                class="input__label"
                :class="{ 'required-input': mandatory }"
                :for="`password_${_uid}`"
                v-text="label || $t('ACCOUNT_FORM_PASSWORD')">
            </label>
            <input
                autocapitalize="off"
                :id="`password_${_uid}`"
                class="input__field input__password"
                :name="`password_${_uid}`"
                :type="passwordInputType"
                v-model="password">
            <img :src="getImgUrl"
                class="input__show_password"
                alt="Show/hide password"
                @click="showHidePassword">
            <!-- Validation -->
            <p class="input__message"
               v-if="message"
               v-html="message">
            </p>
            <p class="input__message"
               v-else-if="!isSecure"
               v-html="$t(errorHandler.get('password'))">
            </p>
        </div>

        <!-- Show Password checkbox field -->
        <!-- <div class="input" :class="{'-mt-4' : !isSecure}">
            <div class="input__checkbox">
                <input
                    :id="`${_uid}-show-password`"
                    type="checkbox"
                    class="input__checkbox-item"
                    v-model="showPassword">
                <label
                    class="input__checkbox-label input__checkbox-label--small-text"
                    :for="`${_uid}-show-password`"
                    v-html="$t('ACCOUNT_FORM_SHOW_PASSWORD')"/>
            </div>
        </div> -->
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import PasswordService from '@/services/cms/PasswordService';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';

export default {
    name: 'PasswordField',
    props: {
        label: {
            default: null,
            type: String,
        },
        requireStrongPassword: {
            default: false,
            type: Boolean,
        },
        value: {
            default: null,
            type: String,
        },
        message: {
            required: false,
            type: String,
            default: null,
        },
        isValid: {
            default: true,
            type: Boolean,
        },
        mandatory: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            password: null,
            showPassword: false,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        passwordInputClass() {
            if (this.value === null && this.isValid === true) {
                return 'input';
            }

            return !this.isSecure ? 'input input--invalid' : 'input input--success';
        },

        passwordInputType() {
            return this.showPassword ? 'text' : 'password';
        },

        isSecure() {
            return !this.errorHandler.has('password') && this.isValid;
        },
        getImgUrl() {
            if (!this.isSecure) {
                return require('@/assets/images/decoration/icons/show-password-red.svg');
            }
            return require('@/assets/images/decoration/icons/show-password.svg');
        },
    },
    methods: {
        showHidePassword() {
            this.showPassword = !this.showPassword;
        },
        validatePassword(value) {
            PasswordService.isPasswordNotBlacklisted(value)
                .then(() => this.errorHandler.reset())
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
    },
    watch: {
        password: debounce(function(value) {
            this.$emit('input', value);
            value !== null && this.requireStrongPassword ? this.validatePassword(value) : false;
        }, 500),
        value: {
            immediate: true,
            handler(value) {
                this.password = value;
            },
        },
    },
};
</script>
